import styled from 'styled-components';
import UnstyledSelect from 'react-select';
import UnstyledInput from 'react-maskedinput';

export const Divider = styled.div `
  margin-top: 20px;
`;

export const List = styled.ul`
margin-top: 10px;
  li {
    margin: 5px 0;
    border-bottom: 1px solid #a4aaad;
  }
  h5 {
    font-weight: bold;
    color: #333;
  }
`;

export const DetailInfoWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  alingn-items: center;
  
  img {
  min-width: 200px;
  max-width: 300px;
  }
`;

export const InstWrapper = styled.div`
  display: flex;
  @media (max-width: 800px){
    flex-direction: column;
  }
`;

export const InstImage = styled.div`
	margin-right: 50px;
	margin-top: 10px;
	margin-bottom: 10px;
  img {
    max-width: 300px;
  }
`;

export const EmptyList = styled.div`
  margin: 20px 0 20px 20px;
  h5 {
    font-weight: bold;
  }
`;

export const Label = styled.div `
  font-size: 12px;
  font-weight: bold;
`;

export const SearchFail = styled.h4 `
  padding: 10px;
`;

export const Error = styled.div `
  font-size: ${props => props.big
	? "18px"
	: "14px"};
  color: #dd4b39;
  margin-top: 10px;
  @media (max-width: 768px){
    font-size: ${props => props.big
		? "14px"
		: "10px"};
    color: #dd4b39;
  }
`;

export const TabsWrapper = styled.div`
  margin-top: 30px;
`;

export const Tip = styled.div `
  font-size: 18px;
`;

export const SelectWrapperAdmin = styled.div`
  margin-top: 10px;
`;

/// refactor adaptive ******//////////
export const UniversalSearchWrapper = styled.form`
display: flex;
flex-wrap: wrap; 

@media (max-width: 708px){
  flex-direction:column;
}
  >div {
    margin-top: 10px;
    margin-right: 10px;
    flex: 1 0 auto;
  }
  >button {
    height: 47px;
    margin-top: 25px;
  }
`;

export const SearchWrapperPortalLowWrap = UniversalSearchWrapper.extend`
  flex-wrap: nowrap;
  @media (max-width: 1200px){
    flex-wrap: wrap;
  }
`

export const UniversalSelectWrapper = styled.div`
`;

export const UniversalDateWrapper = styled.div`
  display: flex;
  @media (max-width: 708px){
    flex-direction: column;
  }
`;

export const UniversalDateTime = styled.div`
  margin-right: 10px;
  width: 100%;
  @media (max-width: 708px){
    margin-top: 10px;
  }
  
  > div, 
  .react-datepicker-wrapper,
   .react-datepicker__input-container {
  	width: 100%;
  }
`;
//////////////////********** */


export const SelectGroup = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	flex-wrap: nowrap;
	flex: 1 1 auto;
	@media (max-width: 1176px){
    flex-wrap: wrap;
  }
  
  > button {
  	margin: 14px 0 0 10px;
			@media (max-width: 1225px) and (min-width: 600px){
				margin: 24px 0 0 10px;
			}
		}
}
`
export const Select = styled.select `

  display: block;
  width: 100%;
  height: auto;
  padding: 6px 16px;
  transition: color 0.1s ease, border-color 0.1s ease;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  border: solid 1px #b3b3b3;
  border-radius: 4px;
  outline: 0;
  height: 46px;
  background: #FFFFFF;
  box-shadow: 0em 0em 0em 0em transparent inset;
  margin-top: 5px;
  @-moz-document url-prefix() {
    &{
      height: 39px;
      font-size: 16px;
    }
`;

export const SelectWithSearch = styled(UnstyledSelect) `
  display: block;
  width: 100%;
  flex: 1 1 auto;
  min-width: 260px;
  transition: color 0.1s ease, border-color 0.1s ease;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  border: solid 1px #b3b3b3;
  border-radius: 4px;
  outline: 0;
  height: 45px;
  padding: 3px 3px; 
  background: #FFFFFF;
  box-shadow: 0em 0em 0em 0em transparent inset;
  margin-top: 5px;
  @-moz-document url-prefix() {
    &{
      height: 38px;
      font-size: 14px;
      padding: 0;
    }
  }
`;

export const SelectWithSearchAsync = styled(UnstyledSelect.Async) `
  display: block;
  width: 100%;
  flex: 1 1 auto;
  min-width: 260px;
  transition: color 0.1s ease, border-color 0.1s ease;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.87);
  border: solid 1px #b3b3b3;
  border-radius: 4px;
  outline: 0;
  // height: 45px;
  padding: 3px 3px; 
  background: #FFFFFF;
  box-shadow: 0em 0em 0em 0em transparent inset;
  margin-top: 5px;
  @-moz-document url-prefix() {
    &{
      height: 38px;
      font-size: 14px;
      padding: 0;
    }
  }
`;

export const MaskedInput = styled(UnstyledInput)`
height: 45px;
@-moz-document url-prefix() {
  &{
    height: auto;
  }
}
width: 100%;
display: block;
box-shadow: none;
padding: 10px 16px;
border: solid 1px #b3b3b3;
color: rgba(0, 0, 0, 0.87);
border-radius: 4px;
margin-top: 5px;
font-size: ${props => props.fontSize || '16px'};
border: ${props => props.hasError ? "1px solid #7f1414" : ""};
@media (max-width: 480px){
  font-size: 14px;
}

&:focus {
  border: solid 1px #ecbc2b;
  box-shadow: none;
  outline: 0 !important;
  color: #2c2c2c;
  transition: all 0.30s ease-in-out;
}
`;

export const Tabs = styled.ul `
  display: flex;

  li {
    margin-right: 10px;
    padding: 10px 0;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
`;


export const RequiredSpan = styled.span`
	color: #edbd2f;
	padding-left: "4px";
	color: ${props => props.hasError ? "#7f1414" : ""};
`



// WEBPACK FOOTER //
// ./src/components/common/index.js